<script setup lang="ts">
  import { ref } from 'vue'
  import AlertQC from '@qicgroupdoha/qic-connect-ds/components/AlertQC'
  import { ALERT_TEST_ID } from './AlertContainer.constants'

  interface Alert {
    id: symbol
    message: string
  }

  const alerts = ref<Alert[]>([])

  const add = (message: string, timeout?: number) => {
    const alert = {
      id: Symbol('alert'),
      message,
    }

    alerts.value.push(alert)

    if (timeout) {
      setTimeout(() => {
        remove(alert.id)
      }, timeout)
    }
  }

  const remove = (id: symbol) => {
    alerts.value = alerts.value.filter((alert) => alert.id !== id)
  }

  defineExpose({
    add,
    remove,
  })
</script>

<template>
  <div class="alert-container">
    <div class="alert-container__alerts">
      <TransitionGroup name="alert-slide">
        <AlertQC
          v-for="alert in alerts"
          :key="alert.id"
          variant="error"
          :subtitle="alert.message"
          closable
          :data-test="ALERT_TEST_ID"
          class="alert-container__alert"
          @close="remove(alert.id)"
        />
      </TransitionGroup>
    </div>
  </div>
</template>

<style lang="scss">
  @forward './AlertContainer.style';
</style>
